import { IFormContext, arraySearch } from 'rewire-ui';
import { capitalCase }               from 'change-case';
import { ReasonCategories }          from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import DataQueries                   from '../graphql/Queries';
import mainPageModel                 from '../main-navigation/MainPageModel';
import DocumentDialogModel           from './DocumentDialogModel';

const ReasonSchema = `
  id
  code
  name
  tags
  category
  fields
`;

export class ReasonDialogModel extends DocumentDialogModel {
  constructor() {
    super(
      'Reason',
      (ids: string[]) => DataQueries.getReasonsByIds(ReasonSchema, ids),
      DataMutations.insertReasons,
      DataMutations.updateReasons,
      DataMutations.deleteReasons,
      'reasons',
      () => mainPageModel.canAddReasons,
      () => mainPageModel.canEditReasons,
      () => mainPageModel.canDeleteReasons,
    );
  }

  protected otherFields(form: IFormContext) {
    return {
      category: form
        .select(arraySearch(Object.values(ReasonCategories), (item: any) => (item && capitalCase(item)) || ''))
        .label('Category')
        .placeholder('select category'),
    };
  }
}

const reasonDialogModel = new ReasonDialogModel();
export default reasonDialogModel;
